import { render } from "./score.vue?vue&type=template&id=4ed960f3&scoped=true"
import script from "./score.vue?vue&type=script&lang=js"
export * from "./score.vue?vue&type=script&lang=js"

import "./score.vue?vue&type=style&index=0&id=4ed960f3&scoped=true&lang=less"
import "./score.vue?vue&type=style&index=1&id=4ed960f3&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed960f3"]])

export default __exports__